import { Modal } from "antd";
import React from "react";

function SelectedBlueprintModal({
  getBlueprintAutoFill,
  setSelectedBlueprintModalFlag,
  selectedBlueprintModalFlag,
  selectedJdDetailData,
  setSelectedBlueprint,
  selectedBlueprint,
}) {
  console.log(selectedJdDetailData);

  const handleCancel = () => {
    setSelectedBlueprintModalFlag(false);

    setSelectedBlueprint((prev) => ({
      previous: prev?.previous, // previous stays as previous
      current: prev?.previous, // restore previous as current
    }));
  };
  return (
    <Modal
      open={selectedBlueprintModalFlag}
      onCancel={() => handleCancel()}
      title={
        <div className="text-gray-900 font-semibold text-xl">
          {selectedJdDetailData?.blueprintName}
        </div>
      }
      centered
      footer={null}
      width={600}
    >
      <div className="text-[#475467] text-[1rem]">
        {selectedJdDetailData?.blueprintDescription}
      </div>
      <div className="mt-2 text-[#ED6B43] text-[.9rem] font-semibold">
        {selectedBlueprint?.previous &&
          "Note: If you select another blueprint, your current data might be lost."}
      </div>
      <div className="flex justify-end items-center gap-3 mt-4">
        <button
          onClick={() => handleCancel()}
          className="rounded-md px-5 border-2 py-1"
        >
          Cancel
        </button>
        <button
          onClick={() => {
            getBlueprintAutoFill(
              selectedJdDetailData?.blueprintId,
              selectedJdDetailData.blueprintName,
              selectedJdDetailData.blueprintType
            );
          }}
          className="py-1 px-5 btn-orange"
        >
          Proceed
        </button>
      </div>
    </Modal>
  );
}

export default SelectedBlueprintModal;
